import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deletePost } from "@/adapters/api";
import { removePostFromCaches } from "@/features/feed/utils/cache.ts";

export function useDeletePost(postId: string) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: () => deletePost(postId),
		onSuccess: () => {
			removePostFromCaches(queryClient, postId);
		},
	});
}
